type StatusWithDate = {
  status: EarnedStatus,
  date: Date
} | {
  status: NotEarnedStatuses
};

export type BadgeStatus = EarnedStatus | NotEarnedStatuses
type EarnedStatus = 'earned'
type NotEarnedStatuses = 'unknown' | 'not-earned'


export type BadgeState = {
  id: string
} & StatusWithDate;

export function defaultBadgeState(id: string) {
  return { id, status: 'unknown' as 'unknown' };
}
